import { render, staticRenderFns } from "./ElementStudioTabsAndPanels.vue?vue&type=template&id=6064e6ac&"
import script from "./ElementStudioTabsAndPanels.vue?vue&type=script&lang=ts&"
export * from "./ElementStudioTabsAndPanels.vue?vue&type=script&lang=ts&"
import style0 from "./ElementStudioTabsAndPanels.vue?vue&type=style&index=0&id=6064e6ac&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports